import { render, staticRenderFns } from "./CoozzySidebarNavTitle.vue?vue&type=template&id=ef267756&scoped=true"
import script from "./CoozzySidebarNavTitle.vue?vue&type=script&lang=js"
export * from "./CoozzySidebarNavTitle.vue?vue&type=script&lang=js"
import style0 from "./CoozzySidebarNavTitle.vue?vue&type=style&index=0&id=ef267756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef267756",
  null
  
)

export default component.exports